import { useState } from "react";
import { Check, ChevronsUpDown, Search } from "lucide-react";
import {
  Popover, PopoverContent, PopoverTrigger,
} from "./ui/popover";
import {
  Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from "./ui/command";

// Searchable select built on shadcn Popover + Command.
export default function SearchSelect({
  value, onChange, options = [], placeholder = "Select…",
  searchPlaceholder = "Search…", disabled, testId, icon: Icon,
}) {
  const [open, setOpen] = useState(false);
  const norm = options
    .filter(Boolean)
    .map((o) => (typeof o === "string" ? { value: o, label: o } : o));
  const selected = norm.find((o) => o.value === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          disabled={disabled}
          data-testid={testId}
          className="w-full h-14 px-4 flex items-center justify-between gap-3 rounded-xl bg-muted/50 border border-border text-left text-foreground transition-colors hover:border-primary/50 focus:border-primary focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <span className="flex items-center gap-3 min-w-0">
            {Icon && <Icon className="h-5 w-5 text-primary shrink-0" />}
            <span className={`truncate ${selected ? "text-foreground" : "text-muted-foreground/70"}`}>
              {selected ? selected.label : placeholder}
            </span>
          </span>
          <ChevronsUpDown className="h-4 w-4 text-muted-foreground/70 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="p-0 w-[--radix-popover-trigger-width] bg-card border-border"
        align="start"
      >
        <Command className="bg-transparent">
          <div className="flex items-center border-b border-border px-3">
            <Search className="h-4 w-4 text-muted-foreground/70" />
            <CommandInput placeholder={searchPlaceholder} className="text-foreground h-11" />
          </div>
          <CommandList>
            <CommandEmpty className="py-6 text-center text-sm text-muted-foreground/70">No results found.</CommandEmpty>
            <CommandGroup>
              {norm.map((o) => (
                <CommandItem
                  key={o.value}
                  value={o.label}
                  data-testid={testId ? `${testId}-option-${o.value}` : undefined}
                  onSelect={() => { onChange(o.value); setOpen(false); }}
                  className="text-foreground/90 aria-selected:bg-muted aria-selected:text-foreground cursor-pointer"
                >
                  <Check className={`mr-2 h-4 w-4 text-primary ${value === o.value ? "opacity-100" : "opacity-0"}`} />
                  {o.label}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
